import { escapeHtml } from './VisualEditorDrawerConstants.ts';

export function showDeleteConfirmDialog(
  dialogElement: HTMLElement | null,
  widgetId: string,
  widgetName: string,
  onConfirm: () => Promise<void> | void
): void {
  if (!dialogElement) return;

  dialogElement.innerHTML = `
    <div class="ve-modal-dialog" role="document">
      <div class="ve-dialog-header">
        <div class="ve-dialog-cad-tag">[ CONFIRM // DELETE ]</div>
        <button type="button" class="ve-dialog-close" id="ve-btn-dialog-close" aria-label="Cancel">✕</button>
      </div>
      <div class="ve-dialog-body">
        <div class="ve-dialog-icon">⚠️</div>
        <div class="ve-dialog-content">
          <h3 class="ve-dialog-title" id="ve-confirm-title">Delete Widget?</h3>
          <p class="ve-dialog-desc">
            Are you sure you want to remove <strong class="ve-dialog-target-name">${escapeHtml(widgetName)}</strong> from this page? This action cannot be undone.
          </p>
        </div>
      </div>
      <div class="ve-dialog-footer">
        <button type="button" class="ve-btn-ghost" id="ve-btn-dialog-cancel">Cancel</button>
        <button type="button" class="ve-btn-danger" id="ve-btn-dialog-delete" data-id="${widgetId}">Delete Widget</button>
      </div>
    </div>
  `;

  const closeDialog = () => {
    dialogElement.classList.remove('open');
    dialogElement.setAttribute('aria-hidden', 'true');
    dialogElement.style.display = 'none';
    dialogElement.innerHTML = '';
    dialogElement.onclick = null;
    document.removeEventListener('keydown', handleKeydown);
  };

  const handleKeydown = (e: KeyboardEvent) => {
    if (e.key === 'Escape') {
      e.preventDefault();
      closeDialog();
    }
  };

  dialogElement.querySelector('#ve-btn-dialog-close')?.addEventListener('click', () => {
    closeDialog();
  });
  dialogElement.querySelector('#ve-btn-dialog-cancel')?.addEventListener('click', () => {
    closeDialog();
  });

  const deleteBtn = dialogElement.querySelector<HTMLButtonElement>('#ve-btn-dialog-delete');
  deleteBtn?.addEventListener('click', () => {
    closeDialog();
    try {
      const result = onConfirm();
      if (result && typeof (result as Promise<void>).then === 'function') {
        (result as Promise<void>).catch((err) => {
          console.error('[VisualEditor] Delete error:', err);
        });
      }
    } catch (err) {
      console.error('[VisualEditor] Delete error:', err);
    }
  });

  dialogElement.onclick = (e) => {
    if (e.target === dialogElement) {
      closeDialog();
    }
  };

  document.addEventListener('keydown', handleKeydown);

  dialogElement.style.display = 'flex';
  dialogElement.classList.add('open');
  dialogElement.setAttribute('aria-hidden', 'false');
  const cancelBtn = dialogElement.querySelector<HTMLButtonElement>('#ve-btn-dialog-cancel');
  cancelBtn?.focus();
}

export function showFileDeleteConfirmDialog(
  dialogElement: HTMLElement | null,
  fileName: string,
  fileUrl: string,
  onConfirm: () => Promise<void> | void
): void {
  if (!dialogElement) return;

  dialogElement.innerHTML = `
    <div class="ve-modal-dialog" role="document">
      <div class="ve-dialog-header">
        <div class="ve-dialog-cad-tag">[ CONFIRM // REMOVE FILE ]</div>
        <button type="button" class="ve-dialog-close" id="ve-btn-dialog-close" aria-label="Cancel">✕</button>
      </div>
      <div class="ve-dialog-body">
        <div class="ve-dialog-icon"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path></svg></div>
        <div class="ve-dialog-content">
          <h3 class="ve-dialog-title" id="ve-confirm-title">Remove Attached File?</h3>
          <p class="ve-dialog-desc">
            Are you sure you want to remove <strong class="ve-dialog-target-name">${escapeHtml(fileName)}</strong> from this block? This action cannot be undone.
          </p>
        </div>
      </div>
      <div class="ve-dialog-footer">
        <button type="button" class="ve-btn-ghost" id="ve-btn-dialog-cancel">Cancel</button>
        <button type="button" class="ve-btn-danger" id="ve-btn-dialog-delete" data-url="${escapeHtml(fileUrl)}">Remove File</button>
      </div>
    </div>
  `;

  const closeDialog = () => {
    dialogElement.classList.remove('open');
    dialogElement.setAttribute('aria-hidden', 'true');
    dialogElement.style.display = 'none';
    dialogElement.innerHTML = '';
    dialogElement.onclick = null;
    document.removeEventListener('keydown', handleKeydown);
  };

  const handleKeydown = (e: KeyboardEvent) => {
    if (e.key === 'Escape') {
      e.preventDefault();
      closeDialog();
    }
  };

  dialogElement.querySelector('#ve-btn-dialog-close')?.addEventListener('click', () => {
    closeDialog();
  });
  dialogElement.querySelector('#ve-btn-dialog-cancel')?.addEventListener('click', () => {
    closeDialog();
  });

  const deleteBtn = dialogElement.querySelector<HTMLButtonElement>('#ve-btn-dialog-delete');
  deleteBtn?.addEventListener('click', () => {
    closeDialog();
    try {
      const result = onConfirm();
      if (result && typeof (result as Promise<void>).then === 'function') {
        (result as Promise<void>).catch((err) => {
          console.error('[VisualEditor] File delete error:', err);
        });
      }
    } catch (err) {
      console.error('[VisualEditor] File delete error:', err);
    }
  });

  dialogElement.onclick = (e) => {
    if (e.target === dialogElement) {
      closeDialog();
    }
  };

  document.addEventListener('keydown', handleKeydown);

  dialogElement.style.display = 'flex';
  dialogElement.classList.add('open');
  dialogElement.setAttribute('aria-hidden', 'false');
  const cancelBtn = dialogElement.querySelector<HTMLButtonElement>('#ve-btn-dialog-cancel');
  cancelBtn?.focus();
}
